import type { Condition } from '@__generated__/globalTypes';

import ProductList from '../ProductList';
import CustomerOffers from '../ProductList/CustomerOffers';
import type { FinderState } from '../url';

type ProductListWrapperProps = {
  isPageProtected: boolean;
  condition: Condition | null;
  language: string;
  searchState: FinderState;
  children?: React.ReactNode;
};

const ProductListWrapper = ({
  isPageProtected,
  condition,
  language,
  searchState,
}: ProductListWrapperProps) => {
  if (isPageProtected) {
    return (
      <CustomerOffers
        condition={condition}
        language={language}
        searchState={searchState}
      />
    );
  }

  return (
    <ProductList
      condition={condition}
      language={language}
      searchState={searchState}
    />
  );
};

export default ProductListWrapper;
